import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    minHeight: 104,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: 8,
    marginBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8,
    paddingBottom: 8,
    borderRadius: 16,
    backgroundColor: 'rgba(195, 155, 225, 0.2)',
    overflow: 'hidden',
  },
  title: {
    paddingTop: 6,
    textAlign: 'left',
    textTransform: 'uppercase',
    fontWeight: 700,
    fontSize: 18,
  },
  main: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  value: {
    fontSize: 24,
    fontFamily: 'Poppins',
    fontWeight: 700,
    textAlign: 'left',
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
  },
  description: {
    fontSize: 14,
    fontFamily: 'Poppins',
    fontWeight: 500,
    textAlign: 'left',
  },
}));
